// src/api/images.js
import ImageKit from "imagekit-javascript";
import { apiFetch } from "../lib/request";

const IMAGEKIT_PUBLIC_KEY = process.env.REACT_APP_IMAGEKIT_PUBLIC_KEY;
const IMAGEKIT_URL= process.env.REACT_APP_IMAGEKIT_URL;

/**
 * GET /images/auth
 * Returns: { token, expire, signature }
 */
export async function fetchImagekitAuth() {
  const json = await apiFetch("/images/auth", { method: "GET" });

  if (!json?.success) throw new Error(json?.error?.message || "ImageKit auth failed");

  let { token, expire, signature } = json.result || {};
  if (!token || !expire || !signature) {
    throw new Error("Invalid ImageKit auth response (missing token/expire/signature)");
  }

  expire = Number(expire); // ✅ important
  if (!Number.isFinite(expire)) throw new Error("Invalid expire (not a number)");

  return { token, expire, signature };
}


/**
 * Upload a file to ImageKit.
 * Supports BOTH:
 *   uploadToImagekit(file)
 *   uploadToImagekit({ file, fileName, folder, tags })
 */
export async function uploadToImagekit(input) {
  if (!IMAGEKIT_PUBLIC_KEY) throw new Error("Missing REACT_APP_IMAGEKIT_PUBLIC_KEY");
  if (!IMAGEKIT_URL) throw new Error("Missing iMAGEKIT_URL yo");
  

  // Allow calling with a File/Blob directly
  const isBlobLike =
    input instanceof Blob || (typeof File !== "undefined" && input instanceof File);

  const opts = isBlobLike ? { file: input } : (input || {});
  const { file, fileName, folder = null, tags = [] } = opts;

  if (!file) throw new Error("Missing file");



  const auth = await fetchImagekitAuth();
const token = String(auth.token);
const signature = String(auth.signature);
let expire = Number(auth.expire);

if (expire > 1e12) expire = Math.floor(expire / 1000); // safety

console.log("AUTH USED", { token, expire, signature, expireType: typeof expire });


  const ik = new ImageKit({
    publicKey: IMAGEKIT_PUBLIC_KEY,
    urlEndpoint: IMAGEKIT_URL,
  });

  const uploaded = await new Promise((resolve, reject) => {
    ik.upload(
      {
        file,
        fileName: fileName || file.name || `upload-${Date.now()}`,
        token,
        expire,
        signature,
        ...(folder ? { folder } : {}),
        ...(tags.length ? { tags } : {}),
        useUniqueFileName: true,
      },
      (err, res) => (err ? reject(err) : resolve(res))
    );
  });

  return uploaded; // { url, fileId, width, height, ... }
}
